// Noodl SDK - webpack handles this require properly
const Noodl = require('@noodl/noodl-sdk');
const React = require('react');
import { ProjectView } from '@shared/components/ProjectView/ProjectView';

export const ProjectViewNode = Noodl.defineReactNode({
	name: 'Prodikt Project View',
	category: 'Prodikt Views',
	getReactComponent() {
		return ProjectView;
	},
	inputProps: {
		// Data
		projects: {
			type: 'array',
			displayName: 'Projects',
			default: [],
			group: 'Data'
		},
		user: {
			type: 'object',
			displayName: 'User',
			default: {},
			group: 'Data'
		},

		// Layout
		viewType: {
			type: {
				name: 'enum',
				enums: [
					{ label: 'Grid View', value: 'grid-view' },
					{ label: 'List View', value: 'list-view' }
				]
			},
			displayName: 'View Type',
			default: 'grid-view',
			group: 'Layout'
		},

		columns: {
			type: {
				name: 'enum',
				enums: [
					{ label: 'Responsive (Auto)', value: 0 },
					{ label: '1 Column', value: 1 },
					{ label: '2 Columns', value: 2 },
					{ label: '3 Columns', value: 3 },
					{ label: '4 Columns', value: 4 }
				]
			},
			displayName: 'Columns',
			default: 0,
			group: 'Layout'
		},

		gap: {
			type: 'number',
			displayName: 'Gap (px)',
			default: 24,
			group: 'Layout'
		},

		// Text
		notEntered: {
			type: 'string',
			displayName: 'Not Entered Text',
			default: '',
			group: 'Text'
		}
	},
	outputProps: {
		projectId: {
			type: 'string',
			displayName: 'Project ID',
			group: 'Project Click Data'
		},
		onProjectClick: {
			type: 'signal',
			displayName: 'Project Clicked'
		},
		menuProjectId: {
			type: 'string',
			displayName: 'Menu Project ID',
			group: 'Menu Action Data'
		},
		actionId: {
			type: 'string',
			displayName: 'Action ID',
			group: 'Menu Action Data'
		},
		onProjectMenuAction: {
			type: 'signal',
			displayName: 'Menu Action'
		}
	},
	setup: function(context, graphModel) {
		if (!context.propsInput) context.propsInput = {};
	},
	initialize: function() {
		const node = this;

		// Set up onProjectClick handler
		this.props.onProjectClick = (projectId) => {
			// Set using the methods
			node.setProjectId(projectId);
			node.sendSignalOnOutput('onProjectClick');
		};

		// Set up onProjectMenuAction handler
		this.props.onProjectMenuAction = (projectId, actionId) => {
			// Set using the methods
			node.setMenuProjectId(projectId);
			node.setActionId(actionId);

			node.sendSignalOnOutput('onProjectMenuAction');
		};
	},
	methods: {
		setProjectId: function(value) {
			this.outputPropValues = this.outputPropValues || {};
			this.outputPropValues.projectId = value;
			this.flagOutputDirty('projectId');
		},
		setMenuProjectId: function(value) {
			this.outputPropValues = this.outputPropValues || {};
			this.outputPropValues.menuProjectId = value;
			this.flagOutputDirty('menuProjectId');
		},
		setActionId: function(value) {
			this.outputPropValues = this.outputPropValues || {};
			this.outputPropValues.actionId = value;
			this.flagOutputDirty('actionId');
		}
	}
});
